module.exports = __webpack_public_path__ + "23148bce1da4968f309ad984e2afb3f9.svg";